var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      staticClass: "sl-modal",
      attrs: {
        id: "processPayment",
        value: _vm.processPaymentModalOpen,
        "no-esc-dismiss": true,
        "no-backdrop-dismiss": true,
        maximized: _vm.maximized,
        "content-css": { width: "1300px", height: "800px" }
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c(
                "q-toolbar-title",
                [
                  _c("q-icon", { attrs: { name: "attach_money" } }),
                  _vm._v(" " + _vm._s(_vm.placeOrderText) + "\n            ")
                ],
                1
              ),
              _c("q-icon", {
                staticClass: "gt-sm",
                attrs: { size: "20px", name: "filter_none" },
                nativeOn: {
                  click: function($event) {
                    _vm.toggleMaximized()
                  }
                }
              }),
              _c("q-icon", {
                attrs: { name: "clear" },
                nativeOn: {
                  click: function($event) {
                    _vm.paymentModalOpenState(false)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-stepper",
            {
              ref: "stepper",
              attrs: { color: "primary", "alternative-labels": "" },
              model: {
                value: _vm.currentStep,
                callback: function($$v) {
                  _vm.currentStep = $$v
                },
                expression: "currentStep"
              }
            },
            [
              _c(
                "q-step",
                {
                  staticClass: "no-padding",
                  class: { active: _vm.currentStep == "first" },
                  staticStyle: { background: "#f4f4f4" },
                  attrs: {
                    default: "",
                    name: "first",
                    "active-icon": "fa fa-shopping-cart",
                    title: "Order Details"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "order-details" },
                    [
                      _vm._l(_vm.pendingPayment.items, function(item, i) {
                        return _c(
                          "div",
                          {
                            key: i,
                            staticClass: "sl-row item-row",
                            class: { error: _vm.hasError(i) }
                          },
                          [
                            _c("div", { staticClass: "sl-row" }, [
                              _c(
                                "div",
                                { staticClass: "sl-col-3 text-weight-bolder" },
                                [
                                  _c(
                                    "q-field",
                                    {
                                      attrs: {
                                        error:
                                          _vm.$v.pendingPayment.items.$each[i]
                                            .orderType.$error,
                                        "error-label":
                                          "Please select an Order Type!"
                                      }
                                    },
                                    [
                                      _c("q-select", {
                                        attrs: {
                                          "float-label": "Order Type",
                                          value: item.orderType,
                                          options: _vm.orderTypeOptions,
                                          disable:
                                            !_vm.canEditItem(item) ||
                                            !_vm.canAdd
                                        },
                                        on: {
                                          change: function(val) {
                                            return _vm.updateItemAndShipping({
                                              itemIndex: i,
                                              orderTypeId: val
                                            })
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  item.affiliate
                                    ? _c(
                                        "q-btn",
                                        {
                                          attrs: { color: "positive" },
                                          on: {
                                            click: function($event) {
                                              _vm.onSelectAffiliate({
                                                itemIndex: i,
                                                affiliate: null
                                              })
                                            }
                                          }
                                        },
                                        [
                                          _c("q-icon", {
                                            staticClass: "q-mr-sm",
                                            attrs: {
                                              name: "fa fa-building",
                                              size: "17px"
                                            }
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(item.affiliate.name) +
                                              "\n                                    "
                                          ),
                                          _c("q-icon", {
                                            staticClass: "q-ml-sm",
                                            attrs: {
                                              name: "fa fa-close",
                                              size: "17px"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  item.orderType === 76 && !item.affiliate
                                    ? _c(
                                        "q-field",
                                        {
                                          attrs: {
                                            error:
                                              _vm.$v.pendingPayment.items.$each[
                                                i
                                              ].$dirty &&
                                              item.affiliate == null,
                                            "error-label":
                                              "Which Affiliate should recieve the credits?"
                                          }
                                        },
                                        [
                                          _c(
                                            "q-search",
                                            {
                                              attrs: {
                                                value: item.affiliate,
                                                placeholder: "Search Affiliates"
                                              }
                                            },
                                            [
                                              _c("q-autocomplete", {
                                                attrs: {
                                                  debounce: 500,
                                                  "max-results": 10
                                                },
                                                on: {
                                                  search: _vm.onSearchAffiliate,
                                                  selected: function(
                                                    affiliate
                                                  ) {
                                                    return _vm.onSelectAffiliate(
                                                      {
                                                        itemIndex: i,
                                                        affiliate: affiliate
                                                      }
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "sl-col-1half price price-each"
                                },
                                [
                                  _c("q-input", {
                                    attrs: {
                                      "float-label": "Price Each",
                                      "hide-underline": "",
                                      prefix: "$",
                                      disable: true,
                                      type: "number",
                                      value: item.price || 0
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "sl-col-1half no-padding" },
                                [
                                  _c(
                                    "q-field",
                                    {
                                      attrs: {
                                        helper: _vm.quantityBetweenHelper(item)
                                      }
                                    },
                                    [
                                      _c("q-input", {
                                        attrs: {
                                          prefix: "×",
                                          type: "number",
                                          "float-label": "Quantity",
                                          decimals: 0,
                                          min: item.min || 1,
                                          max: item.max || 1,
                                          disable:
                                            !_vm.canAdd ||
                                            !_vm.canEditItem(item) ||
                                            (!item.min && !item.max),
                                          value: item.quantity || 1
                                        },
                                        on: {
                                          input: function(val) {
                                            _vm.updateItemFromType({
                                              itemIndex: i,
                                              orderType: item.orderType,
                                              quantity: val
                                            })
                                            _vm.updateItemShippingTotal({
                                              itemIndex: i
                                            })
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "sl-col-1 no-padding" },
                                [
                                  _vm.canEditItem(item) && _vm.canAdd
                                    ? _c(
                                        "q-btn",
                                        {
                                          attrs: {
                                            color: "red",
                                            outline: "",
                                            flat: "",
                                            icon: "delete outline"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.onRemoveOrderItem(i)
                                            }
                                          }
                                        },
                                        [
                                          _c("q-tooltip", [
                                            _vm._v("Remove Item")
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "sl-col-3 no-padding-left text-weight-bolder"
                                },
                                [
                                  item.shippingMethodOptions.length > 0
                                    ? _c("q-select", {
                                        attrs: {
                                          "float-label": "Shipping Method",
                                          value: item.shippingMethod,
                                          options: item.shippingMethodOptions,
                                          disable:
                                            !_vm.canEditItem(item) ||
                                            !item.orderType
                                        },
                                        on: {
                                          change: function(val) {
                                            return _vm.updateItemShippingMethod(
                                              {
                                                itemIndex: i,
                                                shippingMethod: val
                                              }
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "sl-col-1 no-padding" },
                                [
                                  item.shippingMethodOptions.length > 0 &&
                                  item.shippingTotal >= 0
                                    ? _c("q-input", {
                                        attrs: {
                                          "float-label": "Shipping Total",
                                          "hide-underline": "",
                                          prefix: "$",
                                          disable: true,
                                          type: "number",
                                          value: item.shippingTotal
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "sl-col-1 no-padding text-weight-bolder item-total",
                                  staticStyle: { float: "right" }
                                },
                                [
                                  _c("q-input", {
                                    attrs: {
                                      "float-label": "Total",
                                      "hide-underline": "",
                                      prefix: "$",
                                      disable: true,
                                      type: "number",
                                      value: _vm.itemTotal(item)
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      }),
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _vm.canAdd
                            ? _c("q-btn", {
                                staticStyle: { margin: "10px 25px" },
                                attrs: {
                                  color: "primary",
                                  icon: "add",
                                  outline: "",
                                  label: "Add Item"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.onAddPendingOrderItem()
                                  }
                                }
                              })
                            : _vm._e(),
                          _c("div", { staticStyle: { "flex-grow": "1" } }),
                          _c(
                            "span",
                            { staticClass: "order-total order-details-tab" },
                            [
                              _vm._v("Order Total: "),
                              _c("b", [
                                _vm._v("$" + _vm._s(_vm.finalTotal) + " ")
                              ]),
                              _vm.pendingPayment.adminBypass.authorized
                                ? _c("span", [_vm._v(" (Admin Override)")])
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                ]
              ),
              _c(
                "q-step",
                {
                  class: { active: _vm.currentStep == "second" },
                  attrs: {
                    name: "second",
                    title: "Billing Information",
                    "active-icon": "fa fa-usd"
                  }
                },
                [
                  _c("div", { staticClass: "sl-row" }, [
                    _c("div", { staticClass: "sl-col-12" }, [
                      _c(
                        "h5",
                        [
                          _c("q-icon", {
                            attrs: { name: "fa fa-info", color: "primary" }
                          }),
                          _vm._v(" Payer Information")
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "sl-col-6",
                        staticStyle: { "padding-top": "12px" }
                      },
                      [
                        !_vm.pendingPayment.customer.USER_ID
                          ? _c("user-auto-complete", {
                              attrs: {
                                error:
                                  _vm.$v.pendingPayment.customer.USER_ID.$error,
                                onSelect: _vm.selectUser,
                                userId: _vm.pendingPayment.customer.USER_ID,
                                disable: !_vm.$p(["ADMIN", "MANAGER"], "or")
                              }
                            })
                          : _vm._e(),
                        _vm.pendingPayment.customer.user.USER_FIRST_NAME
                          ? _c(
                              "div",
                              { staticClass: "text-bold user-info" },
                              [
                                _c("q-icon", {
                                  attrs: {
                                    name: "account_box",
                                    color: "primary",
                                    size: "20px"
                                  }
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.pendingPayment.customer.user
                                        .USER_FIRST_NAME
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.pendingPayment.customer.user
                                        .USER_LAST_NAME
                                    ) +
                                    " "
                                ),
                                _vm.$p(["ADMIN", "MANAGER"], "or")
                                  ? _c("q-btn", {
                                      attrs: {
                                        icon: "fa fa-trash",
                                        round: "",
                                        flat: "",
                                        color: "red"
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          _vm.clearCurrentCustomerProfile()
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "sl-col-6" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": "Phone",
                            before: [{ icon: "phone" }]
                          },
                          model: {
                            value: _vm.pendingPayment.customer.user.USER_PHONE,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.pendingPayment.customer.user,
                                "USER_PHONE",
                                $$v
                              )
                            },
                            expression:
                              "pendingPayment.customer.user.USER_PHONE"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "sl-row" }, [
                    _c("div", { staticClass: "sl-col-6" }, [
                      _c(
                        "h5",
                        [
                          _c("q-icon", {
                            attrs: { name: "location_on", color: "primary" }
                          }),
                          _vm._v(" Billing Address")
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c(
                            "q-field",
                            {
                              staticClass: "col-12",
                              attrs: {
                                error:
                                  _vm.$v.pendingPayment.billingAddress.address1
                                    .$error,
                                "error-label": "Address required"
                              }
                            },
                            [
                              _c("q-input", {
                                directives: [
                                  {
                                    name: "places-autocomplete",
                                    rawName: "v-places-autocomplete",
                                    value: function(place) {
                                      return _vm.placeChange(
                                        place,
                                        "billingAddress"
                                      )
                                    },
                                    expression:
                                      "(place) => placeChange(place, 'billingAddress')"
                                  }
                                ],
                                attrs: { "float-label": "Address 1" },
                                model: {
                                  value:
                                    _vm.pendingPayment.billingAddress.address1,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.pendingPayment.billingAddress,
                                      "address1",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pendingPayment.billingAddress.address1"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c(
                            "q-field",
                            {
                              staticClass: "col-8",
                              attrs: {
                                error:
                                  _vm.$v.pendingPayment.billingAddress.city
                                    .$error,
                                "error-label": "City required"
                              }
                            },
                            [
                              _c("q-input", {
                                attrs: { "float-label": "City" },
                                model: {
                                  value: _vm.pendingPayment.billingAddress.city,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.pendingPayment.billingAddress,
                                      "city",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pendingPayment.billingAddress.city"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-field",
                            {
                              staticClass: "col-4",
                              attrs: {
                                error:
                                  _vm.$v.pendingPayment.billingAddress.state
                                    .$error,
                                "error-label": "State required"
                              }
                            },
                            [
                              _c("q-select", {
                                ref: "billingStateDropdown",
                                attrs: {
                                  "float-label": "State",
                                  options: _vm.stateOptions,
                                  filter: "",
                                  "autofocus-filter": ""
                                },
                                on: {
                                  focus: function($event) {
                                    _vm.onDropdownFocus("billingStateDropdown")
                                  }
                                },
                                model: {
                                  value:
                                    _vm.pendingPayment.billingAddress.state,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.pendingPayment.billingAddress,
                                      "state",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pendingPayment.billingAddress.state"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c(
                            "q-field",
                            {
                              staticClass: "col-6",
                              attrs: {
                                error:
                                  _vm.$v.pendingPayment.billingAddress.zip
                                    .$error,
                                "error-label": "Zip Required"
                              }
                            },
                            [
                              _c("q-input", {
                                attrs: { "float-label": "Zip" },
                                model: {
                                  value: _vm.pendingPayment.billingAddress.zip,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.pendingPayment.billingAddress,
                                      "zip",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pendingPayment.billingAddress.zip"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-field",
                            { staticClass: " col-6" },
                            [
                              _c("q-input", {
                                attrs: { "float-label": "County" },
                                model: {
                                  value:
                                    _vm.pendingPayment.billingAddress.county,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.pendingPayment.billingAddress,
                                      "county",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pendingPayment.billingAddress.county"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "sl-col-6" }, [
                      _c(
                        "h5",
                        [
                          _c("q-icon", {
                            attrs: { name: "local_shipping", color: "primary" }
                          }),
                          _vm._v(" Mailing Address "),
                          _c("q-checkbox", {
                            staticStyle: { "margin-left": "20px" },
                            model: {
                              value: _vm.pendingPayment.sameAsBilling,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.pendingPayment,
                                  "sameAsBilling",
                                  $$v
                                )
                              },
                              expression: "pendingPayment.sameAsBilling"
                            }
                          }),
                          _c("span", [_vm._v("Same as Billing")])
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.pendingPayment.sameAsBilling,
                              expression: "!pendingPayment.sameAsBilling"
                            }
                          ]
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "q-field",
                                {
                                  staticClass: "col-12",
                                  attrs: {
                                    error:
                                      _vm.$v.pendingPayment.mailingAddress
                                        .address1.$error,
                                    "error-label": "Address required"
                                  }
                                },
                                [
                                  _c("q-input", {
                                    directives: [
                                      {
                                        name: "places-autocomplete",
                                        rawName: "v-places-autocomplete",
                                        value: function(place) {
                                          return _vm.placeChange(
                                            place,
                                            "mailingAddress"
                                          )
                                        },
                                        expression:
                                          "(place) => placeChange(place, 'mailingAddress')"
                                      }
                                    ],
                                    attrs: { "float-label": "Address 1" },
                                    model: {
                                      value:
                                        _vm.pendingPayment.mailingAddress
                                          .address1,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.pendingPayment.mailingAddress,
                                          "address1",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "pendingPayment.mailingAddress.address1"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "q-field",
                                {
                                  staticClass: "col-8",
                                  attrs: {
                                    error:
                                      _vm.$v.pendingPayment.mailingAddress.city
                                        .$error,
                                    "error-label": "City required"
                                  }
                                },
                                [
                                  _c("q-input", {
                                    attrs: { "float-label": "City" },
                                    model: {
                                      value:
                                        _vm.pendingPayment.mailingAddress.city,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.pendingPayment.mailingAddress,
                                          "city",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "pendingPayment.mailingAddress.city"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-field",
                                {
                                  staticClass: "col-4",
                                  attrs: {
                                    error:
                                      _vm.$v.pendingPayment.mailingAddress.state
                                        .$error,
                                    "error-label": "State required"
                                  }
                                },
                                [
                                  _c("q-select", {
                                    ref: "shippingStateDropdown",
                                    attrs: {
                                      "float-label": "State",
                                      options: _vm.stateOptions,
                                      filter: "",
                                      "autofocus-filter": ""
                                    },
                                    on: {
                                      focus: function($event) {
                                        _vm.onDropdownFocus(
                                          "shippingStateDropdown"
                                        )
                                      }
                                    },
                                    model: {
                                      value:
                                        _vm.pendingPayment.mailingAddress.state,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.pendingPayment.mailingAddress,
                                          "state",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "pendingPayment.mailingAddress.state"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "q-field",
                                {
                                  staticClass: "col-6",
                                  attrs: {
                                    error:
                                      _vm.$v.pendingPayment.mailingAddress.zip
                                        .$error,
                                    "error-label": "Zip Required"
                                  }
                                },
                                [
                                  _c("q-input", {
                                    attrs: { "float-label": "Zip" },
                                    model: {
                                      value:
                                        _vm.pendingPayment.mailingAddress.zip,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.pendingPayment.mailingAddress,
                                          "zip",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "pendingPayment.mailingAddress.zip"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-field",
                                { staticClass: "col-6" },
                                [
                                  _c("q-input", {
                                    attrs: { "float-label": "County" },
                                    model: {
                                      value:
                                        _vm.pendingPayment.mailingAddress
                                          .county,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.pendingPayment.mailingAddress,
                                          "county",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "pendingPayment.mailingAddress.county"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  ])
                ]
              ),
              _c(
                "q-step",
                {
                  staticClass: "finalize",
                  class: { active: _vm.currentStep == "third" },
                  attrs: {
                    name: "third",
                    title: "Finalize Payment",
                    "active-icon": "fa fa-check"
                  }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-5 payment-method-left" },
                      [
                        _vm.pendingPayment.paymentType != null &&
                        _vm.$p(["ADMIN"])
                          ? _c(
                              "div",
                              { staticClass: "bypass" },
                              [
                                _vm.pendingPayment.adminBypass.authorized
                                  ? _c(
                                      "span",
                                      { staticClass: "authorized-badge" },
                                      [
                                        _c("q-icon", {
                                          attrs: { name: "check" }
                                        }),
                                        _vm._v(
                                          "\n                                Authorized\n                            "
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c("q-btn", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        !_vm.pendingPayment.adminBypass
                                          .active ||
                                        !_vm.pendingPayment.adminBypass
                                          .authorized,
                                      expression:
                                        "!pendingPayment.adminBypass.active || !pendingPayment.adminBypass.authorized"
                                    }
                                  ],
                                  staticClass: "bypass-btn",
                                  attrs: {
                                    color: "grey-7",
                                    round: "",
                                    outline: "",
                                    icon: "fa fa-key"
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.preAdminBypass({ active: true })
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.pendingPayment.adminBypass.active == true &&
                        _vm.$p(["ADMIN"])
                          ? _c(
                              "div",
                              [
                                _c("q-btn", {
                                  attrs: {
                                    color: "secondary",
                                    icon: "fa fa-arrow-left",
                                    flat: "",
                                    label: "Back"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.preAdminBypass({ active: false })
                                    }
                                  }
                                }),
                                _c("div", { staticClass: "admin-bypass" }, [
                                  _c(
                                    "form",
                                    {
                                      on: {
                                        submit: function($event) {
                                          $event.preventDefault()
                                          _vm.authorizeBypass()
                                        }
                                      }
                                    },
                                    [
                                      _c("q-input", {
                                        attrs: {
                                          "float-label":
                                            "Confirm Admin Password",
                                          type: "password",
                                          disable: _vm.authorizingBypass
                                        },
                                        model: {
                                          value:
                                            _vm.pendingPayment.adminBypass
                                              .password,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.pendingPayment.adminBypass,
                                              "password",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "pendingPayment.adminBypass.password"
                                        }
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "text-right" },
                                        [
                                          _c("q-btn", {
                                            attrs: {
                                              color: "green",
                                              icon: "vpn key",
                                              label: "Authorize",
                                              type: "submit",
                                              loading: _vm.authorizingBypass
                                            }
                                          }),
                                          _vm.madeAuthorizeBypassCall
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "authorize-helper"
                                                },
                                                [
                                                  !_vm.bypassAuthorized
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-red"
                                                        },
                                                        [
                                                          _c("q-icon", {
                                                            attrs: {
                                                              name:
                                                                "error_outline"
                                                            }
                                                          }),
                                                          _vm._v(
                                                            " Error Authenticating"
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm.bypassAuthorized
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-green"
                                                        },
                                                        [
                                                          _c("q-icon", {
                                                            attrs: {
                                                              name: "check"
                                                            }
                                                          }),
                                                          _vm._v(
                                                            " Successfully Authorized"
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        (_vm.showOptions && _vm.pendingPayment.existingOrNew) ||
                        _vm.pendingPayment.existingOrNew == "later"
                          ? _c("q-btn", {
                              staticClass: "options-back",
                              attrs: {
                                color: "secondary",
                                icon: "fa fa-arrow-left",
                                flat: "",
                                label: "Back"
                              },
                              on: {
                                click: function($event) {
                                  _vm.setExistingOrNew(null)
                                  _vm.setPaymentType(null)
                                }
                              }
                            })
                          : _vm._e(),
                        !_vm.pendingPayment.adminBypass.active &&
                        _vm.pendingPayment.existingOrNew == "later"
                          ? _c(
                              "div",
                              [
                                _c("p", { staticClass: "q-pt-lg q-pb-sm" }, [
                                  _vm._v(
                                    "This order will still be processed but marked as "
                                  ),
                                  _c("b", [_vm._v("Unpaid")]),
                                  _vm._v(", Continue?")
                                ]),
                                _c("q-btn", {
                                  attrs: {
                                    icon: "send",
                                    color: "positive",
                                    label: "Yes, Finalize Order"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.onPayLaterFinalize()
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.showOptions
                          ? _c("div", { staticClass: "options" }, [
                              !_vm.pendingPayment.existingOrNew
                                ? _c(
                                    "div",
                                    { staticClass: "text-center" },
                                    [
                                      _vm.pendingPayment.customer
                                        .paymentProfiles &&
                                      _vm.pendingPayment.customer
                                        .paymentProfiles.length > 0
                                        ? _c("q-btn", {
                                            staticStyle: {
                                              "margin-bottom": "10px"
                                            },
                                            attrs: {
                                              color: "primary",
                                              icon: "credit card",
                                              label: "Existing Payment Methods"
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.setExistingOrNew("existing")
                                                _vm.setPaymentType(
                                                  "Credit Card"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        [
                                          _c("q-btn", {
                                            attrs: {
                                              color: "green",
                                              icon: "add",
                                              label: "New Payment Method"
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.setExistingOrNew("new")
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm.$p(["ADMIN"]) &&
                                      !_vm.pendingPayment.wasPayLater
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "10px"
                                              }
                                            },
                                            [
                                              _c("q-btn", {
                                                attrs: {
                                                  outline: "",
                                                  color: "grey-8",
                                                  icon: "schedule_send",
                                                  label: "Pay Later"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.onPayLater()
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.pendingPayment.existingOrNew == "existing"
                                ? _c(
                                    "div",
                                    [
                                      _c("h6", [
                                        _vm._v("Use Existing Method:")
                                      ]),
                                      _c("q-select", {
                                        attrs: {
                                          options:
                                            _vm.pendingPayment.customer
                                              .paymentProfiles,
                                          placeholder: "Select Method",
                                          "float-label": "",
                                          before: [{ icon: "credit card" }]
                                        },
                                        model: {
                                          value:
                                            _vm.pendingPayment.customer
                                              .selectedPaymentProfile,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.pendingPayment.customer,
                                              "selectedPaymentProfile",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "pendingPayment.customer.selectedPaymentProfile"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.pendingPayment.existingOrNew == "new"
                                ? _c("div", { staticClass: "text-center" }, [
                                    _c("h6", [_vm._v("Select New Method:")]),
                                    _c(
                                      "div",
                                      [
                                        _c("q-btn", {
                                          staticStyle: {
                                            "margin-bottom": "10px"
                                          },
                                          attrs: {
                                            color: "primary",
                                            icon: "credit card",
                                            outline: "",
                                            label: "Credit Card"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.setPaymentType("Credit Card")
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm.$p(["ADMIN"])
                                      ? _c(
                                          "div",
                                          [
                                            _c("q-btn", {
                                              staticStyle: {
                                                "margin-bottom": "10px"
                                              },
                                              attrs: {
                                                color: "grey-7",
                                                icon: "fa fa-bank",
                                                outline: "",
                                                label: "ACH Payment"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.onACHPayment()
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.$p(["ADMIN"])
                                      ? _c(
                                          "div",
                                          [
                                            _c("q-btn", {
                                              staticStyle: {
                                                "margin-bottom": "10px"
                                              },
                                              attrs: {
                                                color: "green-7",
                                                icon: "fa fa-money",
                                                outline: "",
                                                label: "Money Order"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.onMoneyOrder()
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    !_vm._.some(
                                      _vm.pendingPayment.items,
                                      function(x) {
                                        return x.orderType == 76
                                      }
                                    )
                                      ? _c(
                                          "div",
                                          [
                                            _c("q-btn", {
                                              staticStyle: {
                                                "margin-bottom": "10px"
                                              },
                                              attrs: {
                                                color: "green-7",
                                                icon: "fa fa-usd",
                                                outline: "",
                                                label: "Account Credits"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.onUseCredits()
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      [
                                        _c("q-btn", {
                                          staticStyle: {
                                            "margin-bottom": "10px",
                                            opacity: "0.2 !important"
                                          },
                                          attrs: {
                                            disable: true,
                                            color: "green",
                                            icon: "fa fa-paypal",
                                            outline: "",
                                            label: "Paypal"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.setPaymentType("Paypal")
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm.pendingPayment.paymentType != null &&
                        !_vm.pendingPayment.adminBypass.active &&
                        _vm.pendingPayment.existingOrNew == "new"
                          ? _c(
                              "div",
                              [
                                _c("q-btn", {
                                  staticStyle: { "margin-bottom": "20px" },
                                  attrs: {
                                    color: "secondary",
                                    icon: "fa fa-arrow-left",
                                    flat: "",
                                    label: "Back"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.setPaymentType(null)
                                    }
                                  }
                                }),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.pendingPayment.paymentType ===
                                          "Money Order",
                                        expression:
                                          "pendingPayment.paymentType === 'Money Order'"
                                      }
                                    ],
                                    staticClass: "money-order"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "q-mr-lg" },
                                      [
                                        _c("h6", [_vm._v("Money Order")]),
                                        _c(
                                          "q-field",
                                          {
                                            staticClass: "col-12",
                                            attrs: {
                                              error:
                                                _vm.$v.pendingPayment.moneyOrder
                                                  .notes.$invalid,
                                              "error-label":
                                                "Money Order Notes required!"
                                            }
                                          },
                                          [
                                            _c("q-input", {
                                              attrs: {
                                                type: "textarea",
                                                "stack-label": "Notes"
                                              },
                                              model: {
                                                value:
                                                  _vm.pendingPayment.moneyOrder
                                                    .notes,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.pendingPayment
                                                      .moneyOrder,
                                                    "notes",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "pendingPayment.moneyOrder.notes"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.pendingPayment.paymentType ===
                                          "Account Credits",
                                        expression:
                                          "pendingPayment.paymentType === 'Account Credits'"
                                      }
                                    ],
                                    staticClass: "account-credits"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "q-mr-lg" },
                                      [
                                        _c("h6", [
                                          _vm._v("Use Account Credits")
                                        ]),
                                        _vm.pendingPayment.accountCredits
                                          .affiliate == null
                                          ? _c(
                                              "p",
                                              { staticClass: "text-caption" },
                                              [
                                                _vm._v(
                                                  "Please select an Affiliate with available Credits. "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              { staticClass: "q-mt-md" },
                                              [
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v("Seleted Affiliate")
                                                  ])
                                                ]),
                                                _c(
                                                  "q-btn",
                                                  {
                                                    staticClass:
                                                      "q-mt-sm q-mb-sm",
                                                    attrs: {
                                                      color: "positive"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.selectAccountCreditsAffiliate(
                                                          null
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("q-icon", {
                                                      staticClass: "q-mr-sm",
                                                      attrs: {
                                                        name: "fa fa-building",
                                                        size: "17px"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.pendingPayment
                                                            .accountCredits
                                                            .affiliate.name
                                                        ) +
                                                        "\n                                            "
                                                    ),
                                                    _c("q-icon", {
                                                      staticClass: "q-ml-sm",
                                                      attrs: {
                                                        name: "fa fa-close",
                                                        size: "17px"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    class: {
                                                      "text-red": !_vm.hasEnoughCredits
                                                    }
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        "Credits Available: $" +
                                                          _vm._s(
                                                            _vm.pendingPayment
                                                              .accountCredits
                                                              .affiliate.value
                                                              .availableCredits
                                                          )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                        _vm.pendingPayment.accountCredits
                                          .affiliate == null
                                          ? _c(
                                              "q-field",
                                              {
                                                attrs: {
                                                  error:
                                                    _vm.$v.pendingPayment
                                                      .accountCredits.affiliate
                                                      .$error,
                                                  "error-label":
                                                    "Please select a valid Affiliate."
                                                }
                                              },
                                              [
                                                _c(
                                                  "q-search",
                                                  {
                                                    attrs: {
                                                      value:
                                                        _vm.pendingPayment
                                                          .accountCredits
                                                          .affiliate,
                                                      placeholder:
                                                        "Search Affiliates"
                                                    }
                                                  },
                                                  [
                                                    _c("q-autocomplete", {
                                                      attrs: {
                                                        debounce: 500,
                                                        "max-results": 10
                                                      },
                                                      on: {
                                                        search:
                                                          _vm.onSearchAffiliate,
                                                        selected: function(
                                                          affiliate
                                                        ) {
                                                          return _vm.selectAccountCreditsAffiliate(
                                                            affiliate
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.pendingPayment.paymentType ===
                                          "ACH Payment",
                                        expression:
                                          "pendingPayment.paymentType === 'ACH Payment'"
                                      }
                                    ],
                                    staticClass: "ach-payment"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "q-mr-lg" },
                                      [
                                        _c("h6", [_vm._v("ACH Payment")]),
                                        _c(
                                          "q-field",
                                          {
                                            attrs: {
                                              error:
                                                _vm.$v.pendingPayment.ach
                                                  .routing.$error,
                                              "error-label":
                                                "Routing Number must be 9 Digits"
                                            }
                                          },
                                          [
                                            _c("q-input", {
                                              directives: [
                                                {
                                                  name: "mask",
                                                  rawName: "v-mask",
                                                  value: "999999999",
                                                  expression: "'999999999'"
                                                }
                                              ],
                                              staticStyle: {
                                                "margin-bottom": "10px"
                                              },
                                              attrs: {
                                                "float-label": "Routing Number",
                                                outlined: ""
                                              },
                                              model: {
                                                value:
                                                  _vm.pendingPayment.ach
                                                    .routing,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.pendingPayment.ach,
                                                    "routing",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "pendingPayment.ach.routing"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "q-field",
                                          {
                                            attrs: {
                                              error:
                                                _vm.$v.pendingPayment.ach
                                                  .account.$error,
                                              "error-label":
                                                "Account Number Required. 6 - 17 Digits."
                                            }
                                          },
                                          [
                                            _c("q-input", {
                                              directives: [
                                                {
                                                  name: "mask",
                                                  rawName: "v-mask",
                                                  value: "99999999999999999",
                                                  expression:
                                                    "'99999999999999999'"
                                                }
                                              ],
                                              staticStyle: {
                                                "margin-bottom": "10px"
                                              },
                                              attrs: {
                                                "float-label": "Account Number"
                                              },
                                              model: {
                                                value:
                                                  _vm.pendingPayment.ach
                                                    .account,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.pendingPayment.ach,
                                                    "account",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "pendingPayment.ach.account"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "q-field",
                                          {
                                            attrs: {
                                              error:
                                                _vm.$v.pendingPayment.ach.name
                                                  .$error,
                                              "error-label":
                                                "Account Name Required"
                                            }
                                          },
                                          [
                                            _c("q-input", {
                                              staticStyle: {
                                                "margin-bottom": "10px"
                                              },
                                              attrs: {
                                                "float-label": "Account Name"
                                              },
                                              model: {
                                                value:
                                                  _vm.pendingPayment.ach.name,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.pendingPayment.ach,
                                                    "name",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "pendingPayment.ach.name"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c("q-checkbox", {
                                          attrs: {
                                            label: "Save for Later Use"
                                          },
                                          model: {
                                            value:
                                              _vm.pendingPayment.ach
                                                .saveForLater,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.pendingPayment.ach,
                                                "saveForLater",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "pendingPayment.ach.saveForLater"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.pendingPayment.paymentType ===
                                          "Credit Card",
                                        expression:
                                          "pendingPayment.paymentType === 'Credit Card'"
                                      }
                                    ],
                                    staticClass: "credit-card"
                                  },
                                  [
                                    _c("credit-card", {
                                      ref: "credit-card",
                                      staticClass: "card-helper",
                                      model: {
                                        value: _vm.cardDetail,
                                        callback: function($$v) {
                                          _vm.cardDetail = $$v
                                        },
                                        expression: "cardDetail"
                                      }
                                    }),
                                    _vm.$v.pendingPayment.cc.$invalid
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "cc-error text-center"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    Please fill in all fields!\n                                "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: { "margin-top": "10px" }
                                      },
                                      [
                                        _c("q-checkbox", {
                                          attrs: {
                                            label: "Save for Later Use"
                                          },
                                          model: {
                                            value:
                                              _vm.pendingPayment.cc
                                                .saveForLater,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.pendingPayment.cc,
                                                "saveForLater",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "pendingPayment.cc.saveForLater"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "cc-field-wrap" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            ref: "number",
                                            staticClass:
                                              "q-if q-focus row no-wrap items-end relative-position q-input text-primary",
                                            attrs: { tabindex: "-1" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "q-if-inner col row no-wrap relative-position"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.cardDetail.number,
                                                      expression:
                                                        "cardDetail.number"
                                                    },
                                                    {
                                                      name: "card-focus",
                                                      rawName: "v-card-focus"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "col q-input-target q-no-input-spinner",
                                                  attrs: {
                                                    autocomplete: "off",
                                                    placeholder: "Card Number",
                                                    type: "text",
                                                    name: "number"
                                                  },
                                                  domProps: {
                                                    value: _vm.cardDetail.number
                                                  },
                                                  on: {
                                                    focus: function($event) {
                                                      _vm.cc().focus("number")
                                                    },
                                                    blur: function($event) {
                                                      _vm.cc().blur("number")
                                                    },
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.cardDetail,
                                                        "number",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            ref: "name",
                                            staticClass:
                                              "q-if q-focus row no-wrap items-end relative-position q-input text-primary",
                                            attrs: { tabindex: "-1" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "q-if-inner col row no-wrap relative-position"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.cardDetail.name,
                                                      expression:
                                                        "cardDetail.name"
                                                    },
                                                    {
                                                      name: "card-focus",
                                                      rawName: "v-card-focus"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "col q-input-target q-no-input-spinner",
                                                  attrs: {
                                                    autocomplete: "off",
                                                    placeholder: "Full Name",
                                                    type: "text",
                                                    name: "name"
                                                  },
                                                  domProps: {
                                                    value: _vm.cardDetail.name
                                                  },
                                                  on: {
                                                    focus: function($event) {
                                                      _vm.cc().focus("name")
                                                    },
                                                    blur: function($event) {
                                                      _vm.cc().blur("name")
                                                    },
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.cardDetail,
                                                        "name",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            ref: "expiry",
                                            staticClass:
                                              "q-if q-focus row no-wrap items-end relative-position q-input text-primary",
                                            attrs: { tabindex: "-1" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "q-if-inner col row no-wrap relative-position"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.cardDetail.expiry,
                                                      expression:
                                                        "cardDetail.expiry"
                                                    },
                                                    {
                                                      name: "card-focus",
                                                      rawName: "v-card-focus"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "col q-input-target q-no-input-spinner",
                                                  attrs: {
                                                    autocomplete: "off",
                                                    placeholder: "MM/YY",
                                                    type: "text",
                                                    name: "expiry"
                                                  },
                                                  domProps: {
                                                    value: _vm.cardDetail.expiry
                                                  },
                                                  on: {
                                                    focus: function($event) {
                                                      _vm.cc().focus("expiry")
                                                    },
                                                    blur: function($event) {
                                                      _vm.cc().blur("expiry")
                                                    },
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.cardDetail,
                                                        "expiry",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            ref: "cvc",
                                            staticClass:
                                              "q-if q-focus row no-wrap items-end relative-position q-input text-primary",
                                            attrs: { tabindex: "-1" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "q-if-inner col row no-wrap relative-position"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.cardDetail.cvc,
                                                      expression:
                                                        "cardDetail.cvc"
                                                    },
                                                    {
                                                      name: "card-focus",
                                                      rawName: "v-card-focus"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "col q-input-target q-no-input-spinner",
                                                  attrs: {
                                                    autocomplete: "off",
                                                    placeholder: "CVC",
                                                    type: "number",
                                                    name: "cvc"
                                                  },
                                                  domProps: {
                                                    value: _vm.cardDetail.cvc
                                                  },
                                                  on: {
                                                    focus: function($event) {
                                                      _vm.cc().focus("cvc")
                                                    },
                                                    blur: function($event) {
                                                      _vm.cc().blur("cvc")
                                                    },
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.cardDetail,
                                                        "cvc",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-7 review-items" },
                      [
                        _c("div", { staticClass: "sl-row" }, [
                          _c("div", { staticClass: "sl-col-5" }, [
                            _c(
                              "h5",
                              [
                                _c("q-icon", {
                                  attrs: {
                                    name: "fa fa-list-alt",
                                    color: "primary"
                                  }
                                }),
                                _vm._v(
                                  " \n                                    Order Review "
                                ),
                                _c("q-btn", {
                                  attrs: {
                                    icon: "fa fa-edit",
                                    size: "sm",
                                    round: "",
                                    color: "secondary",
                                    outline: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.$refs.stepper.goToStep("first")
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _c("div", { staticClass: "sl-col-7 text-right" })
                        ]),
                        _vm._l(_vm.pendingPayment.items, function(item, i) {
                          return _c(
                            "div",
                            { key: i, staticClass: "sl-row item-row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "sl-col-4 text-weight-bolder no-padding"
                                },
                                [
                                  _c("q-select", {
                                    attrs: {
                                      "hide-underline": "",
                                      "float-label": "Order Type",
                                      value: item.orderType,
                                      options: _vm.orderTypeOptions,
                                      disable: true
                                    }
                                  }),
                                  item.orderType == 76 && item.affiliate
                                    ? _c(
                                        "span",
                                        { staticClass: "text-positive" },
                                        [
                                          _vm._v(
                                            "For " + _vm._s(item.affiliate.name)
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "sl-col-2" },
                                [
                                  _c("q-input", {
                                    attrs: {
                                      "hide-underline": "",
                                      prefix: "",
                                      type: "number",
                                      "float-label": "Qty.",
                                      disable: true,
                                      value: item.quantity
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "sl-col-2 price no-padding" },
                                [
                                  _c("q-input", {
                                    attrs: {
                                      "float-label": "Unit Price",
                                      "hide-underline": "",
                                      prefix: "$",
                                      disable: true,
                                      type: "number",
                                      value: item.price
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "sl-col-2 price no-padding" },
                                [
                                  _c("q-input", {
                                    attrs: {
                                      "float-label": "Shipping",
                                      "hide-underline": "",
                                      prefix: "$",
                                      disable: true,
                                      type: "number",
                                      value: item.shippingTotal
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "sl-col-2 text-weight-bolder" },
                                [
                                  _c("q-input", {
                                    attrs: {
                                      "float-label": "Total",
                                      "hide-underline": "",
                                      prefix: "$",
                                      disable: true,
                                      type: "number",
                                      value: _vm.itemPrice(item)
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        _c("div", { staticClass: "sl-row" }, [
                          _vm.bypassAuthorized
                            ? _c(
                                "div",
                                {
                                  staticClass: "sl-col-12 text-right sl-vp ",
                                  attrs: { id: "adminBypassText" }
                                },
                                [
                                  _c(
                                    "h5",
                                    [
                                      _c("small", [_vm._v("Admin Override")]),
                                      _vm._v(": "),
                                      _c("q-input", {
                                        staticStyle: {
                                          width: "100px",
                                          float: "right"
                                        },
                                        attrs: {
                                          prefix: "$",
                                          value: _vm.overrideTotal,
                                          type: "number"
                                        },
                                        on: {
                                          input: function(val) {
                                            return _vm.updateAdminOverrideAmount(
                                              val
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "sl-col-12 text-right sl-vp" },
                            [
                              _c("h5", [
                                _c("small", [_vm._v("Order Total")]),
                                _vm._v(": $" + _vm._s(_vm.finalTotal))
                              ]),
                              _vm.pendingPayment.paymentType ===
                                "Account Credits" &&
                              _vm.pendingPayment.accountCredits.affiliate &&
                              _vm.pendingPayment.accountCredits.affiliate.value
                                .availableCredits >= _vm.finalTotal
                                ? _c("div", [
                                    _c("b", [
                                      _vm._v("Credits After Purchase: "),
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            "text-red": !_vm.hasEnoughCredits
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "$" + _vm._s(_vm.remainingCredits)
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ]
                          )
                        ])
                      ],
                      2
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "q-toolbar",
            {
              staticClass: "sl-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "b",
                {
                  staticClass: "order-total",
                  on: {
                    click: function($event) {
                      _vm.$refs.stepper.goToStep("first")
                    }
                  }
                },
                [
                  _vm._v("Order Total: $" + _vm._s(_vm.finalTotal) + " "),
                  _c("i", [
                    _vm._v("(" + _vm._s(_vm.orderTotalItems) + " Items)")
                  ])
                ]
              ),
              _c("q-toolbar-title"),
              _c("q-btn", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentStep == "first",
                    expression: "currentStep == 'first'"
                  }
                ],
                attrs: { color: "primary", label: "Continue" },
                on: {
                  click: function($event) {
                    _vm.proceedToBilling()
                  }
                }
              }),
              _c("q-btn", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentStep != "first",
                    expression: "currentStep != 'first'"
                  }
                ],
                attrs: { color: "secondary", flat: "", label: "Back" },
                on: {
                  click: function($event) {
                    _vm.$refs.stepper.previous()
                  }
                }
              }),
              _c("q-btn", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.currentStep != "first" && _vm.currentStep != "third",
                    expression:
                      "(currentStep != 'first') && (currentStep != 'third')"
                  }
                ],
                attrs: { color: "primary", label: "Next" },
                on: {
                  click: function($event) {
                    _vm.proceedToPayment()
                  }
                }
              }),
              _c("q-btn", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.currentStep == "third" &&
                      _vm.pendingPayment.existingOrNew != "later",
                    expression:
                      "currentStep == 'third' && pendingPayment.existingOrNew != 'later'"
                  }
                ],
                attrs: {
                  color: "positive",
                  loading: _vm.processing,
                  icon: "send",
                  label: "Finalize Payment"
                },
                on: {
                  click: function($event) {
                    _vm.validateAndPay()
                  }
                }
              }),
              _c("q-btn", {
                attrs: { outline: "", color: "faded", label: "Cancel" },
                on: {
                  click: function($event) {
                    _vm.paymentModalOpenState(false)
                    _vm.setClassProcessing(false)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }